import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from '@chakra-ui/react';
import React from 'react';
import SideBar from '@/components/SideBar';
import { useOutlet } from 'react-router';
import DashboardNavbar from '../DashboardNavbar';
import styles from './SideBarLayout.module.css';
function SideBarLayout(param) {
    var children = param.children, topNavItems = param.topNavItems, bottomNavItems = param.bottomNavItems;
    var outlet = useOutlet();
    if (children == null && outlet == null) {
        throw new Error('Requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsxs(Flex, {
        height: "100vh",
        children: [
            /*#__PURE__*/ _jsx(SideBar, {
                width: "300px",
                topNavItems: topNavItems,
                bottomNavItems: bottomNavItems,
                display: {
                    base: 'none',
                    lg: 'flex'
                }
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                flexDir: "column",
                flex: "1",
                overflowY: "scroll",
                minH: "100vh",
                className: styles.scrollBar,
                children: [
                    /*#__PURE__*/ _jsx(DashboardNavbar, {
                        topNavItems: topNavItems,
                        bottomNavItems: bottomNavItems,
                        display: {
                            base: 'flex',
                            lg: 'none'
                        }
                    }),
                    children
                ]
            })
        ]
    });
}
export default SideBarLayout;
